/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_LocationInputs */

const es_chat_tool_detail_location = /** @type {(inputs: Chat_Tool_Detail_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación`)
};

const en_chat_tool_detail_location = /** @type {(inputs: Chat_Tool_Detail_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Chat_Tool_Detail_LocationInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_location = /** @type {((inputs?: Chat_Tool_Detail_LocationInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_LocationInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_location(inputs)
	return en_chat_tool_detail_location(inputs)
});
export { chat_tool_detail_location as "chat.tool_detail.location" }